import React, { useState } from "react";
import { Album, Resource } from 'app/api/types';

import "./styles.scss";
import EditAlbumForm from './components/EditAlbumForm';
import ManageResourcesForm from './components/ManageResourcesForm';

interface IProps {
  album: Album;
  putAlbums: (album: Album) => void;
  putResource: (payload: { albumId: string, resource: Resource, file?: File, preview?: File }) => void;
  deleteAlbum: (id: string) => void;
  deleteResource: (payload: { id: string, albumId: string }) => void;
}

const AlbumComponent: React.FC<IProps> = (props) => {
  const [isCollapsed, setCollapse] = useState(true);
  const [isDeleting, setDelete] = useState(false);

  const triggerCollapse = () => {
    setCollapse(!isCollapsed);
  };

  const onSubmit = (album: Album) => {
    props.putAlbums(album);
  }

  const onAddResource = (resource: Resource, file: File, preview?: File) => {
    props.putResource({ albumId: props.album.id, resource, file, preview });
  }

  const onDeleteResource = (resource: Resource) => {
    if (!window.confirm('Вы уверены, что хотите удалить фото?')) return;
    props.deleteResource({ id: resource.id, albumId: props.album.id });
  }

  const onDelete = () => {
    if (!window.confirm('Вы уверены, что хотите удалить альбом?')) return;
    setDelete(true);
    props.deleteAlbum(props.album.id);
  };

  const styles = {
    height: !isCollapsed ? "679px" : "90px",
  };

  return (
    <div
      className={`form-container phrase-container ${isDeleting ? "deleting" : ""}`}
      style={styles}
    >
      <div className="phrase-wrapper form-wrapper">
        <img className="image" src={props.album.previewUrl} alt={props.album.name} onClick={triggerCollapse} />

        <div className="left-block" onClick={triggerCollapse}>
          <div className="phrase-text">{props.album.name}</div>
          <div className="phrase-translation"></div>
        </div>

        <div className="right-block">
          <p className="phrase-del" onClick={onDelete}>удалить</p>
        </div>
      </div>

      <EditAlbumForm album={props.album} isActive={!isCollapsed} onSubmit={onSubmit} />

      <ManageResourcesForm album={props.album} isActive={!isCollapsed} onSubmit={onAddResource} onDelete={onDeleteResource} />
    </div>
  );
};

export default AlbumComponent;
